import './search.styl';

import React from 'react';
import classNames from 'classnames';
import {Link} from 'react-router';
import {List} from 'immutable';
import {connect} from 'react-redux';
import Helmet from 'react-helmet';

import * as actions from '../../../common/search/actions';
import {LANGUAGES, languagesMap} from '../../../common/constants/languages';
import {countriesMap} from '../../../common/constants/countries';
import {SEARCH_SOURCES} from '../../../common/constants/searchSources';

import SearchSources from '../search-sources/SearchSources';
import Icon from '../icon/Icon';
import Button from '../button/Button';
import Select from '../select/Select';
import Logo from '../logo/Logo';
import Microphone from '../microphone/Microphone';

const DEFAULT_LANGUAGE = 'en';
const TIMEOUT_DELAY_VALUE = 300;


class Search extends React.Component {
  static propTypes = {
    onSelectSource: React.PropTypes.func.isRequired,
    searchInGoogle: React.PropTypes.func.isRequired,
    toggleTranslateResults: React.PropTypes.func.isRequired,
    translateQuery: React.PropTypes.func.isRequired,
    inputSearch: React.PropTypes.func.isRequired,
    reset: React.PropTypes.func.isRequired,

    searchQueryTranslated: React.PropTypes.string,
    detectedSourceLanguage: React.PropTypes.string,

    location: React.PropTypes.object.isRequired,
    defaultCountry: React.PropTypes.string,
    defaultLanguage: React.PropTypes.string,

    availableCountries: React.PropTypes.any,
    availableLanguages: React.PropTypes.any,

    searchSource: React.PropTypes.string,
    search: React.PropTypes.string,
    searchQuery: React.PropTypes.string,
    pending: React.PropTypes.bool,
    translateResults: React.PropTypes.bool,

    appType: React.PropTypes.string
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    intl: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.onSelectLanguage = this.onSelectLanguage.bind(this);
    this.onSelectCountry = this.onSelectCountry.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.submitSearch = this.submitSearch.bind(this);
    this.toggleTranslateResults = this.toggleTranslateResults.bind(this);
    this.onReset = this.onReset.bind(this);
    this.onChangeSource = this.onChangeSource.bind(this);

    const lr = props.location && props.location.query && props.location.query.lr;
    const gl = props.location && props.location.query && props.location.query.gl;

    let countryObj;
    if (gl) {
      countryObj = countriesMap.get(gl);
    }

    this.translateDelayTimeout = null;
    const languages = this.getLanguages(gl);

    this.state = {
      countries: this.getCountries(lr),
      languages,
      country: countryObj ? countryObj.code : (props.defaultCountry || ''),
      language: lr || (gl && languages[0]) || props.defaultLanguage || ''
    };
  }

  onReset() {
    this.setState({
      countries: this.getCountries(),
      languages: this.getLanguages(),
      language: this.props.defaultLanguage || '',
      country: this.props.defaultCountry || ''
    });
  }

  onInputChange(e) {
    const {translateQuery, inputSearch, searchQuery, currentLocale} = this.props;
    const query = e.target ? e.target.value : e;

    inputSearch(query);

    clearTimeout(this.translateDelayTimeout);
    this.translateDelayTimeout = setTimeout(() => {
      if (query.trim() !== searchQuery.trim() && this.state.language) {
        translateQuery({q: query, targetLanguage: this.state.language, sourceLanguage: currentLocale});
      }
    }, TIMEOUT_DELAY_VALUE);
  }

  onSelectCountry(e) {
    const country = e.target.value;
    const languages = this.getLanguages(country);

    this.setState({
      country,
      languages,
      warn: false
      // language: languages.top.indexOf(this.state.language) !== -1
      //   ? this.state.language
      //   : languages.top[0]
    });
  }

  onSelectLanguage(e) {
    const {translateQuery, searchQuery} = this.props;

    const lang = e.target.value;
    const countries = this.getCountries(lang);

    if (searchQuery && lang && this.state.language !== lang) {
      translateQuery({q: searchQuery, targetLanguage: lang});
    }

    this.setState({
      countries,
      language: lang,
      warn: false,
      // country: countries.top.indexOf(this.state.country) !== -1
      //   ? this.state.country
      //   : countries.top[0]
    });
  }

  submitSearch(e) {
    const {
      searchSource,
      searchInGoogle,
      translateResults,
      searchQuery,
      searchQueryTranslated,
      detectedSourceLanguage
    } = this.props;
    const {language, country} = this.state;

    e.preventDefault();

    if (!language || !country) {
      this.setState({warn: true});
      return false;
    }


    if (!searchQuery) {
      return false;
    }

    const countryObj = countriesMap.get(country);

    const query = {
      q: searchQuery,
      sourceLanguage: detectedSourceLanguage || this.context.intl.locale,
      searchQueryTranslated,
      gl: countryObj && countryObj.code, // Country restrict(s)
      lr: language,
      translateResults,
      searchSource
    };

    searchInGoogle(query);
    this.context.router.transitionTo({
      pathname: '/search',
      query
    });

    return false;
  }

  toggleTranslateResults(e) {
    const {toggleTranslateResults} = this.props;
    toggleTranslateResults(e.target.checked);
  }

  filterAvailableCountries(country) {
    return this.props.availableCountries
      ? this.props.availableCountries.indexOf(country.code) !== -1
      : true;
  }

  filterAvailableLanguages(lang) {
    return this.props.availableLanguages
      ? this.props.availableLanguages.indexOf(lang.name) !== -1
      : true;
  }

  getCountries(language = this.props.defaultLanguage) {
    if (!language) {
      return {
        top: countriesMap
          .filter(this.filterAvailableCountries.bind(this))
          .sortBy(it => it && it.name)
          .keySeq()
          .toArray()
      };
    }

    const countries = languagesMap.get(language).countries;
    const countriesTop = List(countries)
      .filter(this.filterAvailableCountries.bind(this))
      .sortBy(code => countriesMap.get(code).name)
      .toArray();

    return {
      top: countriesTop,
      rest: countriesMap
        .filter(this.filterAvailableCountries.bind(this))
        .filter(country => countriesTop.indexOf(country.code) === -1)
        .sortBy(it => it && it.name)
        .keySeq()
        .toArray()
    };
  }

  getLanguages(country = this.props.defaultCountry) {
    if (!country) {
      return {
        top: languagesMap
          .filter(this.filterAvailableLanguages.bind(this))
          .set(DEFAULT_LANGUAGE, languagesMap.get(DEFAULT_LANGUAGE))
          .valueSeq()
          .sortBy(it => it && it.title)
          .reduce((result, item) =>
            item
              ? result.concat(item.name)
              : result, [])
      };
    }

    const languagesTop = languagesMap
      .filter(this.filterAvailableLanguages.bind(this))
      .filter(lang => lang && lang.countries && lang.countries.indexOf(country) !== -1)
      .set(DEFAULT_LANGUAGE, languagesMap.get(DEFAULT_LANGUAGE))
      .valueSeq()
      .sortBy(it => it && it.title)
      .reduce((result, item) =>
        item
          ? result.concat(item.name)
          : result, []);

    const languagesRest = languagesMap
      .filter(this.filterAvailableLanguages.bind(this))
      .filter(lang => lang && lang.countries && lang.countries.indexOf(country) === -1)
      .valueSeq()
      .sortBy(it => it && it.title)
      .reduce((result, item) =>
        item
          ? result.concat(item.name)
          : result, []);

    return {
      top: languagesTop,
      rest: languagesRest
    };
  }

  onChangeSource(e) {
    const {onSelectSource} = this.props;
    onSelectSource(e.target.value);
  }

  render() {
    const {intl: {formatMessage}} = this.context;
    const {
      reset,
      location,
      pending,
      searchQuery,
      searchQueryTranslated,
      detectedSourceLanguage,
      translateResults,
      searchSource,
      domain
    } = this.props;
    const {language, countries, languages, country} = this.state;

    const title = countriesMap.get(country)
      ? `${searchQuery || formatMessage({id: 'search.meta.try'})} ${formatMessage({id: 'search.meta.in'})} ${countriesMap.get(country).name}`
      : formatMessage({id: 'search.meta.blank'});

    return (
      <div
        className={classNames({
          search: true,
          search_initial: location.pathname === '/'
        })}
      >
        <Helmet
          title={title}
        />
        <div className="search__header">
          <div><Logo /></div>
          <h1 className="search__header-text">{domain}</h1>
          <h2 className="search__header-slogan">
            {formatMessage({id: 'search.header.title'})}
          </h2>
        </div>
        <div className="search__wrapper">
          <Link to="/" className="search__logo" onClick={() => reset()}>
            <Icon name="left" size="xl" />
          </Link>
          <div className="search__container">
            <form action="/search" method="get" onSubmit={this.submitSearch}>
              <div className="search__panel">
                <Button
                  tagName="button"
                  label={formatMessage({id: 'search.search.button'})}
                  type="submit"
                  className="search__button"
                  fullWidth={true}
                  size="m"
                  icon="search"
                  pending={pending}
                />
              </div>
              <div className="search__field">
                <span className="search__field-absolute">
                  {searchQuery.trim().length > 0 &&
                    <Button icon="cross" size="xxs" onClick={() => this.onInputChange('')} />
                  }
                </span>
                <input
                  autoFocus
                  autoComplete="off"
                  id="search"
                  type="text"
                  name="search"
                  value={searchQuery}
                  onChange={this.onInputChange}
                  className="search__input"
                  placeholder={formatMessage({id: 'search.search.placeholder'})}
                />
                <div className="search__query-translated">{searchQueryTranslated}</div>

                <div className="search__microphone">
                  {/*<div className="search__detected-lang">{detectedSourceLanguage}</div>*/}
                  <Microphone onRecognized={this.onInputChange}/>
                </div>
              </div>
              <div
                className={classNames({
                  search__settings: true,
                  search__settings_warn: this.state.warn
                })}
              >
                <div className="search__settings-title">
                  {formatMessage({id: 'search.settings.title'})}
                </div>
                <div className="search__settings-item search__settings-item_cancel">
                  <Button icon="cross" size="xxs" onClick={this.onReset} />
                </div>
                <div className="search__settings-item">
                  <div className="search__languages">
                    <Select>
                      <select
                        name="language"
                        value={language}
                        onChange={this.onSelectLanguage}
                        readOnly={this.props.availableLanguages && this.props.availableLanguages.length === 1}
                      >
                        <option value="">{formatMessage({id: 'search.lang.select'})}</option>
                        <optgroup
                          label={languages.rest
                            ? formatMessage({id: 'search.lang.recommended'})
                            : formatMessage({id: 'search.lang.available'})
                          }
                        >
                          {languages.top.map(langName =>
                            <option value={langName} key={langName}>
                              {LANGUAGES[langName].title}
                            </option>
                          )}
                        </optgroup>
                        {languages.rest &&
                          <optgroup label={formatMessage({id: 'search.lang.others'})}>
                            {languages.rest.map(langName =>
                              <option value={langName} key={langName}>
                                {LANGUAGES[langName].title}
                              </option>
                            )}
                          </optgroup>
                        }
                      </select>
                    </Select>
                  </div>
                </div>
                <div className="search__settings-item">
                  <div className="search__countries">
                    <Select>
                      <select
                        name="country"
                        value={country}
                        onChange={this.onSelectCountry}
                        readOnly={this.props.availableCountries && this.props.availableCountries.length === 1}
                      >
                        <option value="">{formatMessage({id: 'search.countries.select'})}</option>
                        {countries.top && !!countries.top.length &&
                          <optgroup label={countries.rest
                            ? formatMessage({id: 'search.countries.recommended'})
                            : formatMessage({id: 'search.countries.available'})
                          }>
                            {countries.top.map((country, key) =>
                              countriesMap.get(country) && <option value={country} key={key}>
                                {countriesMap.get(country).name}
                              </option>
                            )}
                          </optgroup>
                        }
                        {countries.rest &&
                          <optgroup label={formatMessage({id: 'search.countries.others'})}>
                            {countries.rest.map((country, key) =>
                              countriesMap.get(country) && <option value={country} key={key}>
                                {countriesMap.get(country).name}
                              </option>
                            )}
                          </optgroup>
                        }
                      </select>
                    </Select>
                  </div>
                </div>
                <label className="search__settings-item search__settings-item_label">
                  <input
                    id="translateResults"
                    type="checkbox"
                    name="translateResults"
                    checked={translateResults}
                    onChange={this.toggleTranslateResults}
                  />
                  <span className="search__settings-item-label">
                    {formatMessage({id: 'search.translate.results'})}
                  </span>
                </label>
                {this.state.warn &&
                  <div className="search__settings-warn">{formatMessage({id: 'search.lang.required'})}</div>
                }
              </div>
              <div className="search__settings">
                <SearchSources
                  onChange={this.onChangeSource}
                  items={SEARCH_SOURCES}
                  selected={searchSource}
                  title={formatMessage({id: 'search.sources.header'})}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  currentLocale: state.intl.currentLocale,

  pending: state.search.pending,
  translateResults: state.search.translateResults,
  searchSource: state.search.searchSource,
  searchQuery: state.search.searchQuery,
  searchQueryTranslated: state.search.searchQueryTranslated,
  detectedSourceLanguage: state.search.detectedSourceLanguage,

  defaultCountry: state.search.defaultCountry,
  defaultLanguage: state.search.defaultLanguage,
  availableCountries: state.search.availableCountries,
  availableLanguages: state.search.availableLanguages,

  appType: state.config.appType,
  domain: state.device.domain,
}), actions)(Search);



// WEBPACK FOOTER //
// ./src/client/components/search/Search.js